/* eslint-disable react/no-unknown-property */
/* eslint-disable max-len */
import React from 'react';

/**
 * EmptyIcon - Auto-generated from icon.js
 */
export const EmptyIcon = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="160"
		height="160"
		viewBox="0 0 160 160"
		fill="none"
		{...props}
	>
		<mask id="emptyIcon" mask-type="alpha" maskUnits="userSpaceOnUse" x="11" y="11" width="138" height="138">
			<path d="M80.0011 148.573C117.872 148.573 148.573 117.872 148.573 80.0011C148.573 42.1302 117.872 11.4297 80.0011 11.4297C42.1302 11.4297 11.4297 42.1302 11.4297 80.0011C11.4297 117.872 42.1302 148.573 80.0011 148.573Z" fill="#F5F5F7" />
		</mask>
		<g mask="url(#emptyIcon)">
			<path d="M160 0H0V160H160V0Z" fill="current" />
			<path fillRule="evenodd" clipRule="evenodd" d="M36.5742 96.0017L80.0028 86.8588V105.145L36.5742 96.0017Z" fill="#DDDDDD" />
			<path fillRule="evenodd" clipRule="evenodd" d="M123.43 96.0017L80.0011 86.8588V105.145L123.43 96.0017Z" fill="#D3D3D3" />
			<path fillRule="evenodd" clipRule="evenodd" d="M36.5742 96L80.0028 105.143V160H36.5742V96Z" fill="#DFDFDF" />
			<path fillRule="evenodd" clipRule="evenodd" d="M36.5731 96L80.0017 105.143L68.5731 123.429L25.1445 113.143L36.5731 96Z" fill="#CECECE" />
			<path fillRule="evenodd" clipRule="evenodd" d="M80 105.143L123.429 96V160H80V105.143Z" fill="#F0F0F0" />
			<path fillRule="evenodd" clipRule="evenodd" d="M123.431 96L80.0022 105.143L91.4308 123.429L134.859 113.143L123.431 96Z" fill="#E8E8E8" />
			<g filter="url(#filter0_d)">
				<path d="M80.9543 78.5753C80.6041 79.1005 79.8946 79.2424 79.3694 78.8923C79.2439 78.8086 79.1361 78.7008 79.0524 78.5753L75.4319 73.1445H53.7176C51.8241 73.1445 50.2891 71.6095 50.2891 69.716V44.5731C50.2891 42.6796 51.8241 41.1445 53.7176 41.1445H106.289C108.183 41.1445 109.718 42.6796 109.718 44.5731V69.716C109.718 71.6095 108.183 73.1445 106.289 73.1445H84.5748L80.9543 78.5753Z" fill="black" />
			</g>
			<path d="M80.9543 78.5753C80.6041 79.1005 79.8946 79.2424 79.3694 78.8923C79.2439 78.8086 79.1361 78.7008 79.0524 78.5753L75.4319 73.1445H53.7176C51.8241 73.1445 50.2891 71.6095 50.2891 69.716V44.5731C50.2891 42.6796 51.8241 41.1445 53.7176 41.1445H106.289C108.183 41.1445 109.718 42.6796 109.718 44.5731V69.716C109.718 71.6095 108.183 73.1445 106.289 73.1445H84.5748L80.9543 78.5753Z" fill="#DDDDDD" />
			<path fillRule="evenodd" clipRule="evenodd" d="M66.2879 53.7148C68.1815 53.7148 69.7165 55.2499 69.7165 57.1434C69.7165 59.037 68.1815 60.572 66.2879 60.572C64.3944 60.572 62.8594 59.037 62.8594 57.1434C62.8594 55.2499 64.3944 53.7148 66.2879 53.7148ZM80.0022 53.7148C81.8958 53.7148 83.4308 55.2499 83.4308 57.1434C83.4308 59.037 81.8958 60.572 80.0022 60.572C78.1087 60.572 76.5737 59.037 76.5737 57.1434C76.5737 55.2499 78.1087 53.7148 80.0022 53.7148ZM93.7165 53.7148C95.6101 53.7148 97.1451 55.2499 97.1451 57.1434C97.1451 59.037 95.6101 60.572 93.7165 60.572C91.823 60.572 90.2879 59.037 90.2879 57.1434C90.2879 55.2499 91.823 53.7148 93.7165 53.7148Z" fill="white" />
		</g>
		<defs>
			<filter id="filter0_d" x="38.2891" y="29.1445" width="83.4286" height="61.9398" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
				<feFlood floodOpacity="0" result="BackgroundImageFix" />
				<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
				<feOffset />
				<feGaussianBlur stdDeviation="6" />
				<feColorMatrix type="matrix" values="0 0 0 0 0.5875 0 0 0 0 0.5875 0 0 0 0 0.5875 0 0 0 0.1 0" />
				<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
				<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
			</filter>
		</defs>
	</svg>
);

export default EmptyIcon;
